import { createReducer, on } from "@ngrx/store";
import { saveQuotationsList, resetQuote, setQuote, updateQuotationPrice, updateQuotationIdEntidad } from "./quotation.actions";
import { IQuotation } from "./quotation.models";

export const initialState: IQuotation = null;

export const quotationReducers = createReducer(
    initialState,
    on(setQuote, (state, { quote }) => quote),
    on(updateQuotationPrice, (state, { price }) => { return { ...state, primaTotal: price } }),
    on(updateQuotationPrice, (state, { price }) => { return { ...state, anual: price } }),
    on(resetQuote, (state) => initialState),
    on(saveQuotationsList, (state, { list }) => {return { ...state, list} }),
    on(updateQuotationIdEntidad, (state, { idEntidad }) => { return { ...state, idEntidad: idEntidad } }),
);